// Typelizer digest 3f5747a6f5807cd6b4da07a111d07c7a
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/purchase_orders/:purchase_order_id/finalization */
  create: (
    params: { purchaseOrderId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/purchase_orders/:purchase_order_id/finalization', params, options),
    method: 'post',
  }),
}
